export const exposureSelector = (state) => state.exposure.exposureData;
export const exposureTypesSelector = (state) =>
  state.exposure.exposureData?.exposure_types;
export const buyerExposureSelector = (state) =>
  state.exposure.exposureData?.buyer_exposure;
export const sellerExposureSelector = (state) =>
  state.exposure.exposureData?.seller_exposure;
export const targetExposureSelector = (state) =>
  state.exposure.exposureData?.target_exposure;
